import { Exception as BackendException } from "src/app/shared/services/backend/shared/exceptions/exception.model";

export interface HttpRequestState {
  isBusy?: boolean;
  error?: Exception | undefined;
}

export const DEFAULT_RESET_VALUE = null;

/**
 * This should be a union type of all the exceptions which we can receive from our external systems.
 * Maybe one day we will have to call additional services which return completely different exceptions.
 */
export type Exception = BackendException;
